import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSharedGtmDataStore = defineStore('sharedGtmDataStore', () => {
  const props = {
    hiringNumber: ref<string | undefined>(),
    policyValue: ref<number | undefined>(),
    forWhom: ref<string | undefined>(),
    forWhomPeople: ref<number | undefined>(),
    forWhomOtherPeople: ref<number | undefined>(),
    forWhomPets: ref<number | undefined>(),
    additionalCoverages: ref<boolean | undefined>(),
    hasHealthInsurance: ref<boolean | undefined>(),
    capital: ref<number | undefined>(),
    anotherCompany: ref<boolean | undefined>(false),
    travel_type: ref<string | undefined>(),
    travel_destination: ref<string | undefined>(),
    travel_duration: ref<number | undefined>(),
    ramo: ref<string | undefined>(),
    beneficiaries_type: ref<string | undefined>(),
    beneficiaries_number: ref<number | undefined>()
  }

  function reset() {
    Object.keys(props).forEach((p) => ((props as any)[p].value = undefined))
    props.anotherCompany.value = false
  }

  return { ...props, reset }
})
